/**
 * Application initialization
 * Loads configuration and sets up the application
 */

import { API_ENDPOINTS } from '../config.js';
import { setAccessToken, setDeviceID, setCsrfToken, setVacuumBridge } from './state.js';
import { startWebSocket } from './websocket.js';
import { initDegradation } from './degradation.js';

/**
 * Load application configuration from server
 * @returns {Promise} Resolves when config is loaded
 */
export function loadConfiguration() {
  return new Promise((resolve, reject) => {
    jQuery.getJSON(API_ENDPOINTS.CONFIG, (config) => {
      setAccessToken(config.tempest.accessToken);
      setDeviceID(config.tempest.deviceId);
      setVacuumBridge(config.vacuums || null);
      resolve(config);
    }).fail((xhr, status, error) => {
      console.error('[Init] Failed to load configuration:', error);
      alert('Failed to load configuration. Please refresh the page.');
      reject(error);
    });
  });
}

/**
 * Load CSRF token for chore actions
 * @returns {Promise} Resolves when token is loaded
 */
export function loadCsrfToken() {
  return new Promise((resolve, reject) => {
    jQuery.getJSON(API_ENDPOINTS.CSRF_TOKEN, (data) => {
      setCsrfToken(data.csrfToken);
      resolve(data.csrfToken);
    }).fail((xhr, status, error) => {
      console.error('[Init] Failed to load CSRF token:', error);
      reject(error);
    });
  });
}

/**
 * Initialize the application
 * Loads config, starts WebSocket, and sets up event handlers
 * @returns {Promise} Resolves when initialization is complete
 */
export async function initializeApp() {
  try {
    // Load configuration and CSRF token in parallel
    await Promise.all([
      loadConfiguration(),
      loadCsrfToken(),
    ]);

    // Start WebSocket connection
    startWebSocket();

    // Initialize degradation monitoring
    initDegradation();

    return true;
  } catch (error) {
    console.error('[Init] Failed to initialize application:', error);
    return false;
  }
}
